import React, { useState, useEffect } from 'react';
import { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import ReactTable from 'components/ReactTable/ReactTable';
import { Add, Delete, Edit } from '@material-ui/icons';
import { wsGetAll, wsRemove } from 'services/WService';
import Button from 'components/CustomButtons/Button';
import { Toasty, useToasty } from 'hooks/Toasty';
import NewLayerModal from './NewLayerModal';
import { useModal } from 'hooks/useModal';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 125 },
  { Header: 'Nombre', accessor: 'name', width: 150 },
  { Header: 'Agrupamiento', accessor: 'layerDivition', width: 150 },
  { Header: 'Color', accessor: 'color', width: 70 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Rutas asignadas', accessor: 'routes_count', width: 175 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 5 },
];

function LayerList() {
  const [layers, setLayers] = useState([]);
  const [layerModal, setLayerModal] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);

  async function listLayers() {
    setDataLoading(true);
    let res = await wsGetAll('base/layer');
    setDataLoading(false);
    setLayers(res.data);
  }

  async function deleteLayer(layer) {
    setDataLoading(true);
    let res = await wsRemove('base/layer', layer.id);
    setDataLoading(false);
    if (res.success) {
      showNotify(res.message);
      listLayers();
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    listLayers();
  }, []);

  return (
    <CardContainer
      // title="Listado de capas"
      title={(<>Listado de capas {dataLoading && <LoadingSpinner />}</>)}
      permission={ConstantPermissions.BASE_LAYERS_STORE}
      icon={<Add />}
      onClick={() => {
        setLayerModal({ open: true });
      }}
    >
      <Toasty action={notify} />
      <NewLayerModal
        model={layerModal}
        setOpen={setLayerModal}
        showNotify={showNotify}
        reload={listLayers}
      />
      <ReactTable
        columns={columns}
        data={layers.map((layer, index) => {
          return {
            ...layer,
            layerDivition: layer.divition.name,
            color: (
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <LayerColorIcon
                  layer={layer}
                  style={{
                    display: 'block',
                    height: '30px',
                    width: '30px',
                  }}
                />
              </div>
            ),
            num: (
              <div className="actions-right">
                {index + 1}
                <AllowedGuard permission={ConstantPermissions.BASE_LAYERS_UPDATE}>
                  <Button
                    justIcon
                    round
                    simple
                    color="warning"
                    onClick={() => {
                      setLayerModal({ ...layer, open: true });
                    }}
                  >
                    <Edit />
                  </Button>
                </AllowedGuard>
                <AllowedGuard permission={ConstantPermissions.BASE_LAYERS_DESTROY}>
                  <Button
                    justIcon
                    round
                    simple
                    color="danger"
                    onClick={() => deleteLayer(layer)}
                    disabled={layer.routes_count > 0}
                  >
                    <Delete />
                  </Button>
                </AllowedGuard>
              </div>
            ),
          };
        })}
        exportExcel={false}
      />
    </CardContainer>
  );
}

export default LayerList;
